import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import { AccDTO } from '../../customs/_models/AccDTO';
import { FichePaillasse } from '../../customs/_models/FichePaillasseDTO';


export interface AnalyseInstrumentaleDTO {
  fichePaillasseId: number;
  echantillonId: number;
  typeInstrument: string;
  methodeInstrumentaleId: number;
  batchId?: number;
  dateAnalyse: string;  // ou Date
  operateurId: number;
  statut: string;
  commentaire?: string;
}

export interface SaveStepDTO {
  ficheId: number;
  stepId: number;
  realise: boolean;
  valeurMesuree?: number;
  unite?: string;
  dateRealisation?: string;
  statut?: 'VALIDATED' | 'INCIDENT';
  commentaire?: string;
}


export interface BatchAnalytique {
  id: number;
  batchCode: string;
  typeInstrument: 'GCMSMS' | 'LCMSMS' | string; // ou ton enum TypeInstrument
  methodeInstrumentaleId: number; // ID de la méthode associée
  dateBatch: string; // ISO string (ex: "2025-12-26")
  creeParId?: number; // ID de l'utilisateur qui a créé
  statut: 'EN_COURS' | 'CLOTURE' | string;
  injections?: any[]; // liste des échantillons (optionnel)
}


@Injectable({
    providedIn: 'root'
})
export class FichePaillasseService {

    constructor(private http: HttpClient,
                private endPoint: Endpoints,
                private dialogService: DialogService,) {
    }
  generateFiche(sampleId: number, methodeId: number): Observable<any> {
    return this.http.post(
      `${this.endPoint.fiche_paillasse_base_endpoint}/generate`,
      null,
      {
        params: {
          sampleId: sampleId.toString(),
          methodeId: methodeId.toString()
        }
      }
    );
  }

    getAllFiches(): Observable<FichePaillasse[]> {
    return this.http.get<FichePaillasse[]>(
      `${this.endPoint.fiche_paillasse_base_endpoint}/all`
    );
  }
  addAnalyseInstrumentale(dto: AnalyseInstrumentaleDTO): Observable<AnalyseInstrumentaleDTO> {
    return this.http.post<AnalyseInstrumentaleDTO>(`${this.endPoint.ai_base_endpoint}/create`, dto);
  }

  getMethodesInstrumentales(type: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.endPoint.methodeA_base_endpoint}/methodes/type/${type}`);
  }

  /**
   * Récupère tous les batches
   */
  getBatches(type: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.endPoint.batchA_base_endpoint}/batches/type/${type}`);
  }
    saveFicheValues(fiche: FichePaillasse): Observable<FichePaillasse> {
    return this.http.post<FichePaillasse>(
      `${this.endPoint.fiche_paillasse_base_endpoint}/step/save`,
      fiche
    );
  }
  saveStep(dto: SaveStepDTO): Observable<any> {
    return this.http.post(`${this.endPoint.fiche_paillasse_base_endpoint}/step/save`, dto);
  }

}
